module.exports = __webpack_public_path__ + "static/35import-fcae31bc6fc8f13623d8b2153573c56f.png";